<script setup>

</script>

<template>
  <div class="w-[750px] lg:block hidden">
    <div class="grid grid-cols-5 bg-white shadow rounded-[20px] min-h-[82px]">
      <div class="flex text-center align-middle justify-center border-r-[1px] border-[#ADADAD]">
        <p class="capitalize text-[#2699C6] text-[12px] text-center font-semibold" style="align-content: center">
          ZÁPIS NA WORKSHOP</p>
      </div>
      <div class="col-span-3 items-center flex">
        <p class="px-[25px] text-gray-900 text-[18px] font-medium" style="line-height: 28px">Nejste přihlášeni na žádný
          workshop.</p>
      </div>
      <div class="flex align-middle items-center">
        <div>
          <button class="bg-[#2699C6] px-[25px] py-[14px] rounded-full shadow text-center"><a
            class=" text-white text-[16px] font-semibold" :href="route('frontend.homepage') + '#workshopy'">Zapsat
            se</a>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="lg:hidden flex flex-col items-center bg-white shadow rounded-[20px] gap-2 w-full mx-5">
    <div class="mt-2">
      <p class="capitalize text-[#2699C6] text-[12px] text-center font-semibold" style="align-content: center">
        ZÁPIS NA WORKSHOP</p>
    </div>
    <div>
      <p class="px-[25px] text-gray-900 text-[18px] text-center font-medium" style="line-height: 28px">Nejste přihlášeni na žádný workshop.</p>
    </div>
    <div class="mb-2">
      <button class="bg-[#2699C6] px-[25px] py-[14px] rounded-full shadow text-center"><a
        class=" text-white text-[16px] font-semibold" :href="route('frontend.homepage') + '#workshopy'">Zapsat
        se</a>
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>
